import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import { isSvnMember } from '../store/selectors/ui';
import { emptyStateHelpPath } from '../store/selectors/paths';

export class SvnHowToLink extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    href: PropTypes.string.isRequired,
    isSvn: PropTypes.bool
  };

  render() {
    const { className, href, isSvn } = this.props;
    if (!isSvn) return null;

    return (
      <a
        className={className}
        href={href}
        rel="noopener noreferrer"
        target="_blank"
      >
        <FontAwesomeIcon icon={faQuestionCircle} />
        <span className="ml-2">How to use your Contact Database</span>
      </a>
    );
  }
}

const mapStateToProps = state => ({
  href: emptyStateHelpPath(state),
  isSvn: isSvnMember(state)
});

export default connect(mapStateToProps)(SvnHowToLink);
